import { Component, OnInit } from '@angular/core';
import { StatusMessageComponent } from '../status-message/status-message.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-not-found',
    imports: [StatusMessageComponent, TranslateModule],
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
